module.exports = __webpack_public_path__ + "2fc0b389af5bdc24e8c8dac69734c24b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003AS6.png
// module id = 1515
// module chunks = 0